

















import { Vue, Component } from 'vue-property-decorator';
import PageHeaderOverlay from '@/components/brand/PageHeaderOverlay.vue';
import MenuCard from '@/components/brand/MenuCard.vue';
import { LearnItem } from '../../common/types';

@Component({
  components: {
    PageHeaderOverlay,
    MenuCard,
  },
})
export default class MerchPage extends Vue {
  merchMenu: Array<LearnItem> = [
    {
      img: require('@/assets/bhang_product.jpg'),
      title: 'My Merch',
      id: 1,
    },
    {
      img: require('@/assets/bhang_art_3.jpg'),
      title: 'Order Store Merch',
      id: 0,
    },
  ];
}
